import { ReactElement, useState } from 'react';

import { BackrsChip } from '@backrs_ui/common-ui/src/atoms/BackrsChip';
import { BackrsPDFPreview } from '@backrs_ui/common-ui/src/atoms/BackrsPDFPreview';

import { Theme, SxProps, Box } from '@mui/material';

type NuggetDocumentProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        title: string;
      }
    | {
        type: 'LARGE';
        title: string;
        internalMediaItemUrl?: string;
        externalUrl?: string;
      };
}>;

export const NuggetDocument = ({ variant }: NuggetDocumentProps): ReactElement => {
  const [isLargePDFError, setIsLargePDFError] = useState(false);

  const documentLabel =
    variant.title.length > 30 ? `${variant.title.slice(0, 50)}...` : variant.title;

  if (variant.type === 'LARGE') {
    const DownloadIfErrorView = () => {
      return (
        <Box onClick={() => window.open(variant.internalMediaItemUrl)} sx={downloadErrorStyle}>
          <BackrsChip
            label={`Download ${variant.title}`}
            variant={{
              type: 'SMALL_TEXT',
              leftIcon: {
                name: 'IconDocument',
                alt: 'PDF',
              },
            }}
          />
        </Box>
      );
    };

    if (isLargePDFError) {
      return <DownloadIfErrorView />;
    }

    return (
      <Box
        onClick={() => window.open(variant.internalMediaItemUrl || variant.externalUrl)}
        sx={largeDocumentContainerStyle}
      >
        <BackrsChip
          label={documentLabel}
          variant={{
            type: 'SMALL_TEXT',
            leftIcon: {
              name: 'IconDocument',
              alt: 'PDF',
            },
          }}
        />

        {variant.internalMediaItemUrl ? (
          <BackrsPDFPreview
            documentUrl={variant.internalMediaItemUrl}
            onError={() => setIsLargePDFError(true)}
          />
        ) : variant.externalUrl ? (
          <BackrsPDFPreview
            documentUrl={variant.externalUrl}
            onError={() => setIsLargePDFError(true)}
          />
        ) : null}
      </Box>
    );
  }

  return (
    <Box sx={smallDocumentContainerStyle}>
      <BackrsChip
        label={documentLabel}
        variant={{
          type: 'SMALL_TEXT',
          leftIcon: {
            name: 'IconDocument',
            alt: 'PDF',
          },
        }}
      />
    </Box>
  );
};

const largeDocumentContainerStyle: SxProps<Theme> = {
  mt: 3,
  cursor: 'pointer',
};

const downloadErrorStyle: SxProps<Theme> = {
  mt: 4,
  cursor: 'pointer',
};

const smallDocumentContainerStyle: SxProps<Theme> = {
  mt: 2,
  maxWidth: '200px',
};
